import { Vec2 } from "utils/math/vec2";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";
import { hexToRgba } from "utils/styles/hex-to-rgba";

export class CanvasLineUnitComponent extends Webgl2Component {
  constructor(size: Vec2) {
    super();
    this.transform.setSize(size);
    this.style.pointerEvents = "none";
  }

  public getRenderData() {
    const material = Webgl2.materials.backgroundColor;
    material.setUniform("u_color", hexToRgba("#F25700", true));
    return { material };
  }
}

export default CanvasLineUnitComponent;
